import { makeRdDetailsDescription, RdDocumentationStatus } from '@neo.tax/rd/utils';

import { RdDocumentationBadgeConfig } from './rd-projects-layout.types';

export const getRdDetailsBadgeConfig = (
  consideredForRd: boolean,
  rdDocumentationStatus: RdDocumentationStatus,
): RdDocumentationBadgeConfig | undefined => {
  if (!consideredForRd) {
    return;
  }

  const hasAllDocumentation = Object.values(rdDocumentationStatus).every(Boolean);

  if (hasAllDocumentation) {
    return {
      colorVariant: 'default',
      label: 'Complete',
      description: 'Has no disallowed activities and all required supporting documentation.',
    };
  }

  return {
    colorVariant: 'red',
    label: 'Incomplete',
    description: makeRdDetailsDescription(rdDocumentationStatus),
  };
};
